export default __webpack_public_path__ + "static/media/Logo.ecac9987.png";